/**
 * Class to convert string to HTML
 */
export default class ContentConverter {
	/**
	 * @param {String} content
	 */
	constructor (content) {
		this._content = content;
	}

	get content () {
		return this._content;
	}

	/**
	 * Return object prepared for `dangerouslySetInnerHTML`
	 */
	getReactHtml () {
		return {
			__html: this._content,
		};
	}

	/**
	 * Return HTML string
	 */
	getHtml () {
		return this._content;
	}

	/**
	 * Replace new line wit HTML break
	 */
	nlToBr () {
		this._content = this._content.replace(/(?:\r\n|\r|\n)/g, '<br>');
		return this;
	}

	/**
	 * Convert markdown link to HTML link
	 */
	convertLinks () {
		const regexMdLinks = /\[([^[]+)\]([^[)]+)\)/gm;
		const matches = this._content.match(regexMdLinks);
		if (!matches) return this;
		/**
		 * @param {String} mdLink
		 */
		matches.forEach((mdLink) => {
			this._content = this._content.replace(mdLink, this.getHtmlLink(mdLink));
		});
		return this;
	}

	/**
	 * Return HTML link from parsed from markdown link
	 * @param {*} mdLink Markdown link
	 */
	getHtmlLink (mdLink) {
		const singleMatch = /\[([^[]+)\]\((.*)\)/;
		const parsedLink = singleMatch.exec(mdLink);
		const label = parsedLink[1];
		const href = parsedLink[2];
		if (label.includes('{R}')) return `<Link to="${href}">${label.replace('{R}', '')}</Link>`;
		return `<a href="${href}">${label}</a>`;
	}
}



// WEBPACK FOOTER //
// ./src/utils/contentConverter.js